/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import logging from "utils/logging";
import overlayMixin from "../mixins/overlay-mixin";
import requester from "modules/requester";
import userProfiler from "modules/userprofiler";
import { fromString } from "dom/factory";

export default baustein.register("email-capture-overlay", {
    mixins: [overlayMixin],

    defaultOptions() {
        return {
            overlaySize: "medium",
            noContentPadding: true,
            queryParams: {},
            path: "",
            renderSuccessView: true
        };
    },

    onOverlayOpen() {
        var gender = userProfiler.userProfile.user.gender;
        if (gender) {
            const input = this.el.querySelector('input[name="gender"]');
            if (input) {
                input.value = gender;
            }
        }

        this._setRecentlyViewedProducts();
    },

    getOverlayContent() {
        const request = requester(this.options.path, {
            headers: {
                Accept: "text/html"
            },
            query: this.options.queryParams
        });

        return request.then(r => {
            // a 201 response means there is no content to show but the action has been successful
            if (r.status === 201) {
                this.emit("emailCaptureSuccess");
                this.emit("closeOverlay");
                return Promise.reject();
            }

            return r.text();
        });
    },

    onOverlayCloseIntent() {
        this.close();
        this.emit("closeOverlay");
    },

    setupEvents(add) {
        add("form-submit-success", "ajax-form", this.onSubmitSuccess);
        add("keyup", "input", this.clearErrors);
        add(
            "click",
            ".email-capture-success-overlay__continue-shopping",
            this.onContinueButtonClick
        );
        add("click", '[name="marketing_emails"]', this.onMarketingEmailsChange);
    },

    /**
     * Submits the form by calling `submitForm` on the `ajax-form` component.
     */
    submit() {
        this.findComponent("ajax-form").submitForm();
    },

    /**
     * Handler for the form
     * @param {object} event
     */
    onSubmitSuccess(event) {
        var response = event.formData;

        if (response.success) {
            this.emit("emailCaptureSuccess");

            if (this.options.renderSuccessView) {
                this.setContent(response.data.overlay_html);
            } else {
                this.close();
                this.emit("closeOverlay");
            }
        } else {
            switch (response.error) {
                case "FORM_ERROR":
                    this.handleErrors(response.data.errors);
                    break;
                default:
                    logging.error("Unknown error trying to capture email address.");
            }
        }
    },

    onContinueButtonClick(event) {
        event.preventDefault();
        this.close();
        this.emit("closeOverlay");
    },

    onMarketingEmailsChange() {
        var marketingEmails = this.el.querySelector('[name="marketing_emails"]').checked;
        if (marketingEmails) {
            this.emit("marketingEmailsOn");
        } else {
            this.emit("marketingEmailsOff");
        }
    },

    /**
     * Clears any present error on the email input.
     */
    clearErrors() {
        Array.from(this.el.querySelectorAll(".form-item-error")).forEach(element => {
            element.parentElement.removeChild(element);
        });
    },

    /**
     * Renders the given error messages.
     * @param {string} errorMessage
     */
    handleErrors(errors) {
        this.clearErrors();
        if ("email" in errors) {
            this.showError(errors["email"].join(" "), ".form-item");
        }
        if ("marketing_emails" in errors) {
            this.showError(errors["marketing_emails"].join(" "), ".form-item-legal__gdpr");
        }
    },

    showError(errorMessage, errorSelector) {
        const item = this.el.querySelector(errorSelector);
        if (item) {
            item.appendChild(
                fromString(`
                <div class="form-item-error">${errorMessage}</div>
            `)
            );
        }
    },

    /**
     * [_setRecentlyViewedProducts sets recently viewed products on the `invisible_pids` input]
     */
    _setRecentlyViewedProducts() {
        const seenProducts = userProfiler.getSeenProducts();
        if (seenProducts) {
            const productIds = seenProducts.reduce((memo, product) => {
                memo.push(product.productId);
                return memo;
            }, []);
            let hiddenProductIds = this.el.querySelector('[name="invisible_pids"]');
            hiddenProductIds.value = productIds.join(",");
        }
    }
});

